import { render, staticRenderFns } from "./TextBody.vue?vue&type=template&id=6ad6ee5a&"
import script from "./TextBody.vue?vue&type=script&lang=js&"
export * from "./TextBody.vue?vue&type=script&lang=js&"
import style0 from "./TextBody.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports